export default "__VITE_ASSET__b86f0df2__"